import {
    Box,
    AppBar,
    Toolbar,
    Stack,
    IconButton,
    Divider,
    Drawer,
    List,
    Tab,
    Tabs,
    useMediaQuery,
    useTheme,
    Avatar,
    Menu,
    MenuItem,
} from '@mui/material'
import pxToRem from '../../helpers/pxToRem'
import MenuIcon from '@mui/icons-material/Menu'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import a11yProps from '../../helpers/a11yProps'
import { DrawerIcon } from './helper'
import { useEffect, useState } from 'react'
import { DashboardTabNames, TabNames } from '../../routers/type'
import styles from './DashboardHeader.module.scss'
import HomeIcon from '@mui/icons-material/Home'
import LogoutIcon from '@mui/icons-material/Logout'
import SettingsIcon from '@mui/icons-material/Settings'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import HelpCenterIcon from '@mui/icons-material/HelpCenter'
import sparkLogo from '../../assets/images/share/sparkIcon.png'
import sparkIcon from '../../assets/images/header/Spark Relief Teachers Logo.png'
import { RootState } from '../../redux/store'
import { TeacherAccountState } from '../../firebase/types-teacher'
import useSignOutUser from '../../hooks/useSignOutUser'
import { tabNames } from '../../routers/helpers'

const MENU_ITEMS = [
    {
        label: 'Home',
        name: '',
        link: tabNames.app.teacher.index,
        icon: <HomeIcon />,
    },
    {
        label: 'My Account',
        name: 'my-account',
        link: `${tabNames.app.teacher.index}/${tabNames.app.teacher.MY_ACCOUNT}`,
    },
    {
        label: 'Help Desk',
        name: 'help',
        link: `/${TabNames.HELP_DESK}`,
    },
    {
        label: 'Settings',
        name: 'settings',
        link: `${tabNames.app.teacher.index}/${DashboardTabNames.SETTINGS}`,
    },
]

const TeacherHeader = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const accountState = useSelector(
        (state: RootState) => state.user.accountState
    )
    const rejectedState = useSelector(
        (state: RootState) => state.userReg.rejectedState
    )

    const isUserData = useSelector((state: RootState) => !!state.user.user.data)
    const profilePictureURL = useSelector(
        (state: RootState) => state.user.user.data?.profilePictureURL
    )

    const [drawerOpen, setDrawerOpen] = useState(false)

    const path = location.pathname.substring(
        location.pathname.lastIndexOf('/') + 1
    )
    const [selectedTab, setSelectedTab] = useState(
        path === ''
            ? 0
            : MENU_ITEMS.findIndex(
                  (el) =>
                      el.link.substring(el.link.lastIndexOf('/') + 1) === path
              )
    )
    const onTabChange = (e: React.SyntheticEvent, newValue: number) => {
        if (newValue >= 0 && newValue < MENU_ITEMS.length) {
            navigate(MENU_ITEMS[newValue].link)
            setSelectedTab(newValue)
        }
    }

    useEffect(() => {
        setSelectedTab(
            path === ''
                ? 0
                : MENU_ITEMS.findIndex(
                      (el) =>
                          el.link.substring(el.link.lastIndexOf('/') + 1) ===
                          path
                  )
        )
    }, [path])

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const [anchorEl, setAnchorEl] = useState<null | Element>(null)
    const handleMenu = (event: React.MouseEvent<Element>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const [signOutUser] = useSignOutUser()
    const logout = () => signOutUser(() => navigate('/'))

    const HamburgerMenu = () => (
        <>
            {/* <Toolbar> {!drawerOpen && (<IconButton color="inherit" aria-label="Open menu" edge="start" onClick={() => setDrawerOpen(!drawerOpen)}> <MenuIcon sx={{color:styles.shades100}}/> </IconButton>) } </Toolbar> */}
            <Drawer
                open={drawerOpen}
                anchor={'right'}
                onClose={() => setDrawerOpen(!drawerOpen)}
            >
                <List>
                    <Tabs
                        orientation={'vertical'}
                        value={selectedTab >= 0 ? selectedTab : false}
                        onChange={(e, newValue) => {
                            onTabChange(e, newValue)
                            setDrawerOpen(false)
                        }}
                        sx={{
                            paddingTop: '40px',
                            '& .MuiTabs-indicator': {
                                // backgroundColor: styles.primaryYellow500,
                            },
                            '& .MuiTab-root.Mui-selected': {
                                color: styles.primary500,
                                fontWeight: isMobile ? 600 : 700,
                            },
                        }}
                    >
                        <Tab
                            sx={{
                                '&.MuiTab-root': {
                                    alignItems: 'flex-end',
                                },
                            }}
                            aria-label=""
                            label={DrawerIcon('Home', <HomeIcon />)}
                            className={styles.hamburgerTab}
                            value={0}
                            {...a11yProps(0)}
                        />

                        {!!rejectedState ||
                        accountState ===
                            TeacherAccountState.offboarded ? null : (
                            <Tab
                                sx={{
                                    '&.MuiTab-root': {
                                        alignItems: 'flex-end',
                                    },
                                }}
                                aria-label="my-account"
                                label={DrawerIcon(
                                    'My Account',
                                    <AccountBoxIcon />
                                )}
                                value={1}
                                className={styles.hamburgerTab}
                                {...a11yProps(1)}
                            />
                        )}
                        <Tab
                            sx={{
                                '&.MuiTab-root': {
                                    alignItems: 'flex-end',
                                },
                            }}
                            aria-label="help"
                            label={DrawerIcon('Help Desk', <HelpCenterIcon />)}
                            value={2}
                            className={styles.hamburgerTab}
                            {...a11yProps(2)}
                        />
                        <Tab
                            sx={{
                                '&.MuiTab-root': {
                                    alignItems: 'flex-end',
                                },
                            }}
                            aria-label="settings"
                            label={DrawerIcon('Settings', <SettingsIcon />)}
                            value={3}
                            className={styles.hamburgerTab}
                            {...a11yProps(3)}
                        />
                        <Divider sx={{ width: '80%', alignSelf: 'center' }} />
                        <Tab
                            sx={{ '&.MuiTab-root': { alignItems: 'flex-end' } }}
                            aria-label="settings"
                            label={DrawerIcon('Logout', <LogoutIcon />)}
                            className={styles.hamburgerTab}
                            onClick={logout}
                        />
                    </Tabs>
                </List>
            </Drawer>
        </>
    )

    return (
        <Box sx={{ backgroundColor: '#fff' }}>
            <AppBar
                position="static"
                sx={{
                    height: '100%',
                    padding: `${pxToRem(0)} ${pxToRem(20)}`,
                    backgroundColor: 'inherit',
                    boxShadow: 'none',
                }}
            >
                <Toolbar>
                    <img
                        className={styles.icon}
                        src={sparkIcon}
                        alt="Spark Icon (Text only)"
                        onClick={() => navigate(`/`)}
                    />
                    <Stack
                        direction="row"
                        sx={{ flexGrow: 1, gap: pxToRem(40) }}
                        justifyContent={'flex-end'}
                        alignItems={'center'}
                    >
                        {isMobile ? (
                            <>
                                <IconButton onClick={() => setDrawerOpen(true)}>
                                    <MenuIcon />
                                </IconButton>
                                <HamburgerMenu />
                            </>
                        ) : (
                            <List sx={{ padding: 0 }}>
                                <Tabs
                                    key={`teachers_tabs`}
                                    value={
                                        selectedTab >= 0 && selectedTab < 3
                                            ? selectedTab
                                            : false
                                    }
                                    onChange={onTabChange}
                                    slotProps={{
                                        indicator: {
                                            sx: {
                                                backgroundColor:
                                                    styles.secondaryBlue800,
                                                height: pxToRem(1),
                                                color: styles.secondaryBlue800,
                                                borderColor:
                                                    styles.secondaryBlue800,
                                            },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiTabs-indicator': {
                                            backgroundColor: 'none',
                                        },
                                        '& .MuiTab-root.Mui-selected': {
                                            color: styles.secondaryBlue800,
                                            border: 0,
                                        },
                                        '& button': {
                                            borderRadius: 2,
                                            padding: pxToRem(12),
                                            transition: 'all 300ms',
                                        },
                                        '& button:hover': {
                                            background: 'none',
                                            color: styles.secondaryBlue300,
                                        },
                                        '& button:focus': {
                                            background: 'none',
                                        },
                                        '& button:active': {
                                            background: 'none',
                                        },
                                        '& button.Mui-selected': {
                                            background: 'none',
                                        },
                                        '& button.Mui-disabled': {
                                            color: styles.neutrals200,
                                            background: 'none',
                                        },
                                    }}
                                >
                                    <Tab
                                        aria-label={MENU_ITEMS[0].name}
                                        label={MENU_ITEMS[0].label}
                                        key={`teacher_tab_${0}`}
                                        value={0}
                                        className={styles.hamburgerTab}
                                        {...a11yProps(0)}
                                    />
                                    {!!rejectedState ||
                                    accountState ===
                                        TeacherAccountState.offboarded ? null : (
                                        <Tab
                                            aria-label={MENU_ITEMS[1].name}
                                            label={MENU_ITEMS[1].label}
                                            key={`teacher_tab_${1}`}
                                            value={1}
                                            className={styles.hamburgerTab}
                                            {...a11yProps(1)}
                                        />
                                    )}
                                    <Tab
                                        aria-label={MENU_ITEMS[2].name}
                                        label={MENU_ITEMS[2].label}
                                        key={`teacher_tab_${2}`}
                                        value={2}
                                        className={styles.hamburgerTab}
                                        {...a11yProps(2)}
                                    />

                                    {/* {MENU_ITEMS.slice(0, 3).map((e, i) => (
                                        <Tab
                                            aria-label={e.name}
                                            label={e.label}
                                            key={`teacher_tab_${i}`}
                                            className={styles.hamburgerTab}
                                            {...a11yProps(i)}
                                        />
                                    ))} */}
                                </Tabs>
                            </List>
                        )}
                    </Stack>
                    {!isMobile && isUserData ? (
                        <div>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                                sx={{ marginLeft: pxToRem(40) }}
                            >
                                <Avatar
                                    src={profilePictureURL || sparkLogo}
                                    alt="User Photo"
                                />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                slotProps={{
                                    paper: {
                                        className: styles.dotButtonMenu,
                                    },
                                }}
                                MenuListProps={{
                                    className: styles.menuListcontainer,
                                }}
                            >
                                <MenuItem
                                    className={styles.hoverMenuItem}
                                    onClick={() => {
                                        handleClose()
                                        navigate(
                                            `${tabNames.app.teacher.index}/${DashboardTabNames.SETTINGS}`
                                        )
                                    }}
                                >
                                    Settings
                                </MenuItem>
                                <MenuItem
                                    className={styles.hoverMenuItem}
                                    onClick={logout}
                                >
                                    Logout
                                </MenuItem>
                            </Menu>
                        </div>
                    ) : null}
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default TeacherHeader
